import { render, staticRenderFns } from "./MedicationModalSectionCollapseTemplate.vue?vue&type=template&id=9ba46628&scoped=true&"
import script from "./MedicationModalSectionCollapseTemplate.vue?vue&type=script&lang=ts&"
export * from "./MedicationModalSectionCollapseTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./MedicationModalSectionCollapseTemplate.vue?vue&type=style&index=0&id=9ba46628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba46628",
  null
  
)

export default component.exports